<p-toast [baseZIndex]="9999" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" #myForm autocomplete="off">
      <div class="row">
        <div class="col-4">
          <lib-page-header page-title="ORGÃO PÚBLICO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/office-building.png">
          </lib-page-header>
        </div>
        <div class="col-8">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a routerLink="/orgaos" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="20" width="20">
          </a>
          <button *ngIf="podeIncluir()" (click)="submitForm()"
            class="btn btn-outline-success btn-sm float-right mr-2">Salvar orgão</button>
        </div>
      </div>
      <hr class="mt-1 mb-2" />
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="orgao-tab" data-toggle="tab" href="#orgao" role="tab" aria-controls="orgao"
            aria-selected="true">Orgão Público</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="assinatura-tab" data-toggle="tab" href="#assinatura" role="tab"
            aria-controls="assinatura" aria-selected="false">Assinaturas</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="configuracao-tab" data-toggle="tab" href="#configuracao" role="tab"
            aria-controls="configuracao" aria-selected="false">Configuração</a>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="orgao" role="tabpanel" aria-labelledby="orgao-tab">
          <div class="form-row mt-4">
            <lib-divisor altura="250px" imagem="assets/img/global/manage_sources.png"></lib-divisor>
            <div class="col-md-11 col-lg-11 col-xl-11">
              <div class="form-row">
                <div class="form-group col-md-2">
                  <label for="codigo">Código<span class="text-danger">*</span></label>
                  <input #codigo formControlName="codigo" type="text" class="form-control font-weight-bold"
                    [unmask]="true" [imask]="{ mask: '00.0000'}"
                    [ngClass]="{ 'is-invalid': submitted && f.codigo.errors }">
                </div>
                <div class="form-group col-md-2">
                  <label for="tribunal">N˚ TCE <span class="text-danger">*</span></label>
                  <input formControlName="tribunal" type="text" class="form-control font-weight-bold"
                    [ngClass]="{ 'is-invalid': submitted && f.tribunal.errors }">
                </div>
                <div class="form-group col-md-2">
                  <label for="siafi">SIAFI<span class="text-danger">*</span></label>
                  <input formControlName="siafi" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.siafi.errors }">
                </div>
                <div class="form-group col-md-3">
                  <label for="cnpj">CNPJ<span class="text-danger">*</span></label>
                  <input formControlName="cnpj" class="form-control" [unmask]="false"
                    [imask]="{mask: '00.000.000/0000-00'}" [ngClass]="{ 'is-invalid': submitted && f.cnpj.errors }">
                </div>
                <div class="col-md-3">
                  <label for="especie">Orgão<span class="text-danger">*</span></label>
                  <select formControlName="especie" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.especie.errors }">
                    <option *ngFor="let item of listaEspecies" [value]="item.id">{{item.nome}}</option>
                  </select>
                  <lib-form-field-error [form-control]="entidadeForm.get('especie')"></lib-form-field-error>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="nome">Nome<span class="text-danger">*</span></label>
                  <input formControlName="nome" class="form-control font-weight-bold"
                    [ngClass]="{ 'is-invalid': submitted && f.nome.errors }">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-5">
                  <label for="email">e-mail<span class="text-danger">*</span></label>
                  <input formControlName="email" class="form-control" style="color: #0d47a1;"
                    [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                </div>
                <div class="form-group col-md-5">
                  <label for="site">Site</label>
                  <input formControlName="site" class="form-control">
                </div>
                <div class="form-group col-md-2">
                  <label for="telefone">Telefone<span class="text-danger">*</span></label>
                  <input formControlName="telefone" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.telefone.errors }" [unmask]="false"
                    [imask]="{mask: '(00) 000000000'}">
                </div>
              </div>
            </div>
          </div>
          <div class="form-row mt-3">
            <lib-divisor altura="100px" imagem="assets/img/global/direction.png"></lib-divisor>
            <div class="col-11">
              <div class="form-row">
                <div class="form-group col-md-2">
                  <label for="cep">CEP<span class="text-danger">*</span></label>
                  <input formControlName="cep" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.cep.errors }">
                </div>
                <div class="form-group col-md-6">
                  <label for="endereco">Endereço<span class="text-danger">*</span></label>
                  <input formControlName="endereco" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.endereco.errors }">
                </div>
                <div class="form-group col-md-4">
                  <label for="bairro">Bairro<span class="text-danger">*</span></label>
                  <input formControlName="bairro" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.bairro.errors }">
                </div>
              </div>
            </div>
          </div>
          <div class="form-row mt-3">
            <lib-divisor altura="300px" imagem="assets/img/global/application_view_gallery.png"></lib-divisor>
            <div class="col-11" formGroupName="brasao">
              <div class="row">
                <div class="col-4">
                  <div class="row" *ngIf="entidadeForm.get('brasao').get('brasao').value">
                    <div class="col-12">
                      <img [src]="entidadeForm.get('brasao').get('brasao').value" alt="" />
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-12">
                      <label class="btn btn-sm btn-outline-secondary" for="my-file-selector" for="my-file-selector">
                        <input id="my-file-selector" type="file" style="display:none"
                          (change)="fileChangeEvent($event)" />
                        Selecione o brasão
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-8" style="margin: 0; padding: 0">
                  <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [aspectRatio]="21 / 20" format="png" (imageCropped)="imageCropped($event)" resizeToWidth="200"
                    onlyScaleDown="true">
                  </image-cropper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="assinatura" role="tabpanel" aria-labelledby="assinatura-tab">
          <lib-orgao-assinatura [(lista)]="listaAssinaturas" [(entidade)]="entidade" [login]="login"
            (preencherTabela)="updateAssinatura($event)">
          </lib-orgao-assinatura>
        </div>
        <div class="tab-pane fade" id="configuracao" role="tabpanel" aria-labelledby="configuracao-tab">
          <lib-orgao-configuracao-shw [configuracao]="configuracao"></lib-orgao-configuracao-shw>
        </div>
      </div>
    </form>
  </div>
  <br>
  <br>
  <br>
  <div id="footer" class="row mt-4">
    <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
      <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
        <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
        Salvar e novo
      </button>
    </div>
  </div>
</div>